import script from "./AvatarCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarCard.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarCard.vue?vue&type=style&index=0&id=dcbf923a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcbf923a"]])

export default __exports__